enum DocsSiteSource {
  Search = 'search',
  SearchResults = 'searchResults',
  OpenSourceEditButton = 'openSourceEditButton',
  DocsHomeAssistantButton = 'docsHomeAssistantButton',
  DocsTopNavAssistantButton = 'docsTopNavAssistantButton',
  PageReload = 'pageReload',
  DirectURLVisit = 'directURLVisit',
  LanguageMenu = 'languageMenu',
  OpenCloud = 'openCloud',
  TryItOut = 'tryItOut',
}

export const AssistantDocsSiteSources = [
  DocsSiteSource.DocsHomeAssistantButton,
  DocsSiteSource.DocsTopNavAssistantButton,
  DocsSiteSource.DirectURLVisit,
];

export const CoursesDocsSiteSources = [DocsSiteSource.DirectURLVisit];

export default DocsSiteSource;
